<!--隐私协议-->
<template>
    <div class="agreement">
        <div class="container">
            <p>1.接受条款</p>
            <p>父母牵缘恋爱应用（以下简称“父母牵缘”）由江苏爱驿站信息科技有限公司（以下简称“江苏爱驿站”）开发，根据以下服务条款为您提供服务。江苏爱驿站在此特别提醒您（用户）在注册成为用户之前，请认真阅读本《用户协议》（以下简称“本协议”）及其各项附件（包括但不限于《父母牵缘隐私政策》、《父母牵缘用户行为规范》及其他附件），确保您充分理解本协议中各条款。除非您接受本协议所有条款，否则您无权注册、登录或使用本协议所涉服务。</p>
            <p> 此外，当您使用父母牵缘服务时，您和父母牵缘应遵守因国家政策以及法律法规变化进行修改的与该服务相关的指引和规则。前述所有的指引和规则，均构成本使用协议的一部分。                                                                                                                             </p>
            <p>2.条款的修改</p>
            <p>由于国家政策或法律法规的变化，本协议条款可能进行更新，修改后的条款由江苏爱驿站向您通知或在网站上公告，用户可在本网站查阅最新版协议条款。</p>
            <p>3.注册</p>
            <p>3.1为了能使用本服务，您需要注册父母牵缘账号，应当使用手机号码绑定注册，请用户使用尚未与“父母牵缘”账号绑定的手机号码，以及未被江苏爱驿站封禁的手机号码注册“父母牵缘”账号。根据法律法规的要求，江苏爱驿站可以根据用户需求或产品需要对账号注册和绑定的方式进行变更，您应在法律法规的要求下予以配合。</p>
            <p>3.2“父母牵缘”系基于地理位置的移动社交产品，用户注册时应当授权江苏爱驿站公开及使用其地理位置信息方可成功注册“父母牵缘”账号。故用户完成注册即表明用户同意江苏爱驿站提取、公开及使用用户的地理位置信息。</p>
            <p>3.3鉴于父母牵缘账号的注册方式，且为了保护您账号的安全，您同意江苏爱驿站在注册时使用您提供的手机号码及/或自动提取您的手机号码及您的手机设备识别码等信息用于注册。</p>
            <p>3.4在用户注册及使用本服务时，江苏爱驿站需要搜集能识别用户身份的个人信息以便江苏爱驿站可以在必要时联系用户，或为用户提供更好的使用体验。江苏爱驿站搜集的信息包括但不限于用户的姓名、性别、年龄、出生日期、身份证号、学校情况、公司情况、所属行业、兴趣爱好、常出没的地方、个人说明；江苏爱驿站同意对这些信息的使用将受限于个人隐私信息相关法律和父母牵缘隐私政策的约束。</p>
            <p>3.5您需要确保今后更新的手机号码、名称、头像等资料，以及在父母牵缘上发布的所有内容的有效性和合法性。若您提供任何违法、违反道德以及违反父母牵缘用户行为规范的资料，或者父母牵缘有理由怀疑你进行任何恶意操作，则父母牵缘有权限制或封禁您的账号功能，并拒绝您于现在和未来使用本服务之全部或任何部分。任何用户应对其在父母牵缘上发布的任何登记资料的真实性、正确性、完整性、适用性及/或是否为最新资料承担全部责任。</p>
            <p>根据有关法律法规，父母牵缘在此郑重提请您注意，任何经由本服务而发布、上传的文字、照片、或其它资料（以下简称“内容 ”），无论系公开还是私下传送，均由内容提供者承担责任。父母牵缘仅为用户提供内容存储空间，无法控制经由本服务传送之内容，因此不保证内容的正确性、完整性或品质。您已预知使用本服务时，可能会接触到令人不快、不适当或令人厌恶之内容。在任何情况下，父母牵缘均不为任何内容负责，您可以通过父母牵缘内的举报功能对该等内容进行举报。经核实后，父母牵缘有权依法停止传输任何前述内容并采取相应行动，包括但不限于暂停违规用户使用本服务的全部或部分，保存有关记录，并向有关机关报告。</p>
            <p>4.用户账号、密码及安全</p>
            <p>完成本服务的注册程序并成功注册之后，您可使用您的手机号码，登录到您在父母牵缘的账号（下称“账号”）。</p>
            <p>您应对所有使用您的密码及账号的活动负完全的责任。您同意：</p>
            <p>您的父母牵缘账号遭到未获授权的使用，或者发生其它任何安全问题时，您将立即通知父母牵缘，父母牵缘将在合理的范围内保障您的权益。</p>
            <p>每个用户都要对其账号中的所有行为和事件尽到合理注意义务。如果您未保管好自己的账号和密码而对您、父母牵缘或第三方造成的损害，您将在您的过错范围内承担责任。</p>
            <p>如父母牵缘发现您的账号存在异常登录且账号被盗取的可能性较大，您同意父母牵缘有权对账号进行冻结。如需解冻，请您通过父母牵缘反馈渠道提出申请。</p>
            <p>4.1旨在为用户提供更丰富多样的服务和体验，让更多的会员看到您的相亲交友资料，扩大相亲交友范围，我们会将您的账号信息授权给旗下关联产品联盟APP使用。为了使您能够在多款APP之间获得更便捷、连贯的服务，我们希望在符合法律法规的前提下，实现部分用户资料在多款APP间的共享。</p>
            <p>4.2用户资料共享说明 1. 共享的用户资料范围 当您注册本APP并同意本协议后，若您后续选择使用联盟APP，我们将在您明确授权的情况下，共享以下必要的注册信息： - 用户名：用于在联盟APP中标识您的身份，方便您登录和使用相关服务。 - 头像：使您在联盟APP中保持一致的个人形象展示。 - 注册手机号码：用于账号验证、密码找回等必要的安全和服务功能，确保您的账号安全及能正常接收相关通知信息。 - 性别：为您在联盟APP中提供个性化的服务和内容推荐参考。 - 出生日期：用于根据您的年龄提供合适的服务内容，并符合相关法律法规对于不同年龄段用户的服务规范要求。- 相亲资料：让更多符合您的交友条件的会员看到。- 实名和认证信息：提升的信用背书的作用。</p>
            <p>4.3共享目的 - 提升用户体验：通过共享上述基本信息，您无需在联盟APP中重复填写注册信息，可快速便捷地开始使用，享受连贯一致的服务体验。 - 个性化服务：基于共享的信息，我们能够为您在联盟APP中提供更贴合您需求的个性化内容推荐、服务功能定制等，例如根据您的年龄和性别推荐合适的婚恋对象或相关活动。 - 账号安全与管理：共享注册手机号码等信息有助于我们在不同APP环境下保障您的账号安全，如进行身份验证、防止账号被盗用等，同时也便于我们对您的账号进行统一管理和维护，为您提供更高效的客户服务。 3. 共享方式与安全保障措施 - 我们将采用安全可靠的技术手段和加密传输方式，确保您的信息在从本APP传输至联盟APP的过程中的安全性，防止信息泄露、篡改或丢失。例如，使用SSL加密协议对数据进行加密传输，在传输过程中对数据进行完整性校验等。 - 在接收和存储您的信息时，联盟APP也将遵循严格的安全标准和隐私保护措施。我们会对存储您信息的服务器进行定期的安全检查和维护，设置严格的访问权限控制，只有经过授权的工作人员在履行工作职责必要的情况下才可访问您的信息，且访问过程会被严格记录审计。 - 我们会持续关注信息安全领域的最新技术和法规要求，不断完善和更新我们的安全保障措施，以确保您的信息始终得到妥善保护。</p>
            <p>4.4用户授权 1. 同意方式 当您在本APP注册过程中看到本协议提及的关于用户资料共享APP联盟平台的相关内容并点击“同意”按钮时，即表示您明确授权我们按照本协议约定在本APP与联盟APP之间共享您的相关信息。若您后续不想再授权信息共享，可按照本协议中“用户权利与选择”部分的指引进行操作。 2. 授权的变更与撤回 - 您有权随时变更或撤回您对用户资料共享的授权。如果您希望变更授权范围或撤回授权，您可以在本APP的“设置” - “账号设置“完成注销账号操作。具体操作步骤可能会根据APP的界面设计有所不同，但我们会尽力确保操作流程清晰易懂。 - 当您注销后，我们将停止在本APP与联盟APP之间共享您的信息。但请注意，基于您之前授权共享的信息在联盟APP中已产生的相关记录和操作可能无法立即删除或更改，我们会按照相关法律法规和联盟APP的隐私政策进行妥善处理。</p>
            <p>4.5用户权利与选择 1. 您有权自主决定是否同意本协议中关于用户资料共享的条款。如果您不同意，您无法正常使用本APP的基本功能，无法享受到在联盟APP中使用同步资料带来的便捷服务（如无需重复注册、保持个人信息一致性等）。 2. 您有权查阅、更正、补充或删除您在本APP及联盟APP中的个人信息。具体操作路径为：在本APP“我的-资料编辑”中提交更改。 3. 若您认为我们在信息共享或使用过程中存在违反本协议或法律法规的行为，您有权通过本APP“我的-客服中心”或发送邮件至[官方客服邮箱]进行投诉或举报，我们将在收到后及时核实处理，并向您反馈处理结果。 六、信息使用的限制 1. 除本协议明确约定的共享目的（如为您提供跨APP服务、保障账号安全等）外，我们不会将您的个人信息用于任何其他目的，也不会将其共享给任何第三方（联盟APP作为我们旗下关联产品，不属于“第三方”范畴，但仍需严格遵守本协议及隐私政策的要求）。</p>
            <p>4.6未经您的单独授权，我们及联盟APP均不得将您的个人信息用于服务无关的活动（法律法规另有规定或您明确同意的除外）。</p>
            <p>4.7如因法律法规、司法机关或行政监管部门的强制性要求（如传票、调查令等），我们可能需要向相关部门提供您的个人信息，届时我们将在法律允许的范围内，尽可能提前通知您（除非法律禁止）。 </p>
            <p>5.付费功能使用</p>
            <p>父母牵缘部分增值服务需要付费使用，用户如需购买付费增值服务，可在相应服务的购买页面选购并在父母牵缘开通的支付渠道进行支付，在支付完毕之日即开通相关增值服务功能。</p>
            <p>用户在购买前可通过父母牵缘所公布的页面对相关增值服务的内容进行了解，如有疑问可通过客服进行确认。</p>
            <p>用户购买时应根据实际需求确认购买服务的种类、数量、时长、自动续费期限等。对于父母牵缘依照法律法规的要求对违规用户进行封禁等处理的，父母牵缘将不承担您因此造成的其他损失，且对于已使用部分的费用将不予退还。因该等行为造成父母牵缘损失，且已支付的费用不足以弥补父母牵缘损失的，父母牵缘有权向您继续追偿。</p>
            <p>用户购买父母牵缘付费功能，要求开具发票的，父母牵缘负责开具用户提出要求当年的增值税普通发票，增值税由用户承担；如产生运输费、快递费等由用户承担。</p>
            <p>6.供成员用于非商业用途</p>
            <p>对于父母牵缘所提供的服务，您不得用于任何商业用途，但经父母牵缘明确认可或批准的商业使用除外。禁止非法和/或未经授权使用父母牵缘服务。我们可以在不经任何通知的情况下删除用户档案文件中的商业广告、关联链接和其他形式的推销内容，并且可以因此而终止您的用户资格。对于任何非法或未 经授权使用父母牵缘服务的行为，我们将会采取适当的法律行动。</p>
            <p>7.用户个人隐私信息保护</p>
            <p>用户在注册账号或使用本服务的过程中，可能需要填写或提交一些必要的信息，如法律法规、规章规范性文件（以下称“法律法规”）规定的需要填写的身份信息。如用户提交的信息不完整或不符合法律法规的规定，则用户可能无法使用本服务或在使用本服务的过程中受到限制。</p>
            <p>个人隐私信息是指涉及用户个人身份或个人隐私的信息，江苏爱驿站十分注重保护用户的个人隐私，并制定了《父母牵缘隐私政策》，用户可以通过阅读本协议附件进行具体查看，用户确认并同意使用江苏爱驿站提供的服务将被视为接受《父母牵缘隐私政策》。</p>
            <p>8.用户行为规范</p>
            <p>用户同意将不会利用本服务进行任何违法或不正当的活动，遵守父母牵缘与用户之间的《父母牵缘用户行为规范》。</p>
            <p>9.国际使用之特别警告</p>
            <p>您已了解国际互联网的无国界性，同意遵守当地所有关于网上行为及内容之法律法规。您特别同意遵守有关从中国或您所在国家或地区输出信息之传输的所有适用法律法规。</p>
            <p>10.在父母牵缘发布的公开信息</p>
            <p>在本使用协议中，“本服务公开使用区域”系指一般公众可以使用的区域；</p>
            <p>用户在父母牵缘上传或发布的内容，用户应保证其为著作权人或已取得合法授权，并且该内容不会侵犯任何第三方的合法权益，用户同意授予父母牵缘所有上述内容在全球范围内的免费、不可撤销的、无期限限制的、可再许可或转让的独家使用权许可，据该许可父母牵缘将有权以展示、推广及其他不为法律所禁止的方式使用前述内容。</p>
            <p>11.赔偿</p>
            <p>由于您通过本服务提供、发布或传送之内容、您与本服务连线、您违反本使用协议、或您侵害他人任何权利因而衍生或导致任何第三人提出任何索赔或请求，包括合理的律师费，您同意赔偿父母牵缘及其子公司、关联企业、高级职员、代理人、品牌共有人或其它合作伙伴及员工，并使其免受损害，并承担由此引发的全部法律责任。</p>
            <p>12.数据储存 </p>
            <p>江苏爱驿站根据国际法律法规的要求对与用户有关的数据进行存储，并在您提出符合法律法规的请求后进行相关数据的删除。</p>
            <p>13.服务的变更、中断、终止</p>
            <p>鉴于网络服务的特殊性以及不定时修改的法律法规，用户理解江苏爱驿站可能会在服务提供的过程中因非父母牵缘的原因变更、中断或终止部分或全部的服务（包括收费服务）。江苏爱驿站变更、中断或终止的服务，江苏爱驿站应当在变更、中断或终止之前通知用户，并应向受影响的用户提供等值的替代性的服务；如用户不愿意接受替代性的服务，江苏爱驿站应当按照该用户实际使用服务的情况扣除相应费用之后将剩余的金额退还用户。</p>
            <p>如发生下列任何一种情形，江苏爱驿站有权变更、中断或终止向用户提供的免费服务或收费服务，并有权要求过错方承担法律责任：</p>
            <p>(1) 根据法律规定用户应提交真实信息，而用户提供的个人资料不真实、或与注册时信息不一致又未能提供合理证明；</p>
            <p>(2) 用户违反相关法律法规或本协议的约定；</p>
            <p>(3) 按照法律规定或有权机关的要求；</p>
            <p>(4) 出于安全的原因或其他必要的情形。</p>
            <p>14.担保与保证 </p>
            <p>您明确了解并同意:</p>
            <p>因第三方的原因造成对您的损害，您应根据《侵权责任法》等法律法规向侵权方进行追偿，父母牵缘在法律法规规定的范围内予以配合。</p>
            <p>15.责任限制：不可抗力</p>
            <p>因下列不可抗力的原因导致双方不能履行合同或在合同范围内进行修改的，双方免除全部因不可抗力导致的不能履行或修改合同的责任：</p>
            <p>1、因台风、地震、洪水、雷电、恐怖袭击、火灾等原因；</p>
            <p>2、因病毒、木马、恶意程序攻击、网络拥堵、系统不稳定、系统或设备故障、通讯故障、电力故障、第三方服务瑕疵或政府行为、法律法规的变化。</p>
            <p>3、因您操作不当或违反政府规定或双方约定的行为规范损害公共秩序或侵害父母牵缘、第三方权益的。</p>
            <p>16.父母牵缘商标信息</p>
            <p>父母牵缘Logo、父母牵缘以及其它父母牵缘注册商标、标志及产品、服务名称，均为父母牵缘公司之商标（以下简称“父母牵缘标记”）。未经父母牵缘事先书面同意，您同意不将父母牵缘标记以任何方式展示或使用或作其它处理，或表示您有权展示、使用或另行处理父母牵缘标记。</p>
            <p>17.一般条款</p>
            <p>本使用协议、社区指导原则和免责声明构成您与父母牵缘之全部协议，并规范您对于本服务之使用行为。在您使用相关服务、使用第三方提供的内容或软件时，亦应遵从所适用之附加条款及条件；</p>
            <p>本使用协议及您与父母牵缘之关系，均受到中华人民共和国法律管辖。如您和父母牵缘之间发生任何纠纷或争议，应先尽量友好协商解决；协商不成时，您同意将纠纷或争议提交父母牵缘注册地有管辖权的人民法院进行诉讼；</p>
            <p>父母牵缘未行使或执行本使用协议任何权利或规定，不构成对前述权利或权利之放弃；</p>
            <p>倘本使用协议之任何规定因与中华人民共和国法律抵触而无效，您依然同意应依照法律，努力使该规定所反映之当事人意向具备效力，且本使用协议其它规定仍应具有完整的效力及效果；</p>
            <p>本使用协议之标题仅供方便而设，不具任何法律或契约效果。</p>
            <p></p>
            <p>父母牵缘用户行为规范</p>
            <p>一. 原则</p>
            <p>1、为维护父母牵缘社交软件（以下简称“父母牵缘”）健康生态秩序，更好地保障用户合法权益及良好的用户体验，遵守国家相关法律规定，您在使用父母牵缘时应遵守《父母牵缘用户行为规范》（“本规范”）。</p>
            <p>2、父母牵缘用户在父母牵缘平台的活动须遵守现行法律法规。江苏爱驿站将按照相关法律法规及用户协议规则，对违规行为进行相应的处理。</p>
            <p>3、本规范是父母牵缘《用户协议》不可分割的一部分，请您在使用父母牵缘前仔细阅读本规范，确保您已充分理解本规范中各条款的内容。除非您接受本规范所有内容，否则您无权使用父母牵缘。您使用父母牵缘的行为将视为对本规范的接受，并同意接受本规范内容的约束。</p>
            <p>二、使用规范</p>
            <p>1、发布色情及色情擦边内容的行为。</p>
            <p>散布淫秽、色情内容，包括但不限于招嫖、约炮等内容。</p>
            <p>发布带有色情暗示、挑逗性的音频、文字、动图、外部网站链接和二维码等内容的。</p>
            <p>2、发布任何广告相关信息的行为。例如：微商、招聘、信用卡、贷款、化妆品、数码产品、淘宝店铺、整容整形等广告或一对一的推销。</p>
            <p>3、威胁、污蔑诽谤以及辱骂他人的行为。</p>
            <p>4、盗用他人资料的行为。包括但不限于以下盗用行为：</p>
            <p>擅自发布、使用他人已经登记注册的企业名称或商标，侵犯他人企业名称专用权及商标专用权。</p>
            <p>擅自发布、使用他人名称、照片、身份证号码，侵害他人名誉权、肖像权等合法权利。</p>
            <p>5、冒充父母牵缘官方账号的行为：</p>
            <p>发布、使用、恶搞父母牵缘LOGO等已有知识产权内容相同、相似的字样，或者容易与目前已有父母牵缘产品设计主题、外观等相混淆的内容。</p>
            <p>恶意中伤、侮辱、调侃父母牵缘以及相关产品和技术。</p>
            <p>冒充父母牵缘官方人员向用户发送信息。</p>
            <p>6、违反国家现行法律法规的行为。包括但不限于以下行为：</p>
            <p>反政治活动：反对宪法所确定的基本原则、危害国家安全、颠覆国家政权、煽动民族仇恨、宣扬邪教和封建迷信、非法集会等。</p>
            <p>买卖毒品、买卖假币、买卖枪支弹药以及管制刀具、买卖违禁药物、买卖假证等。</p>
            <p>以谋取利益为目的的虚假社交行为、诈骗行为及其他违反社会公德的不诚信行为。</p>
            <p>发布的信息含有聚众赌博、传授赌博技巧等内容。</p>
            <p>雇佣、引诱他人从事恐怖、暴力等活动</p>
            <p>7、发布血腥、暴力、恐怖、恶心等会令人感到不适内容的行为。包括但不限于以下内容：</p>
            <p>散播人或动物被杀、致残以及枪击、刺伤、拷打等受伤情形的真实画面。</p>
            <p>含有出现描绘暴力或虐待儿童等内容。</p>
            <p>发布替人复仇、暴力催收、宣称黑社会身份等可能扰乱公共秩序的信息。</p>
            <p>8、发布钓鱼网站链接、含木马病毒的网站链接和二维码等可能会对用户造成信息安全影响的内容。</p>
            <p>9、使用外挂及其他恶意行为。包括但不限于以下行为：</p>
            <p>未经父母牵缘书面许可使用插件、外挂或其他第三方工具、服务接入父母牵缘以及相关系统。</p>
            <p>使用外挂、人工进行影响父母牵缘正常运营的行为。</p>
            <p>恶意攻击父母牵缘及相关系统的行为。</p>
            <p>恶意收集父母牵缘系统或其他父母牵缘用户的个人信息的行为。</p>
            <p>制作、发布与以上行为相关的方法、工具，或对此类方法、工具进行运营或传播的行为。</p>
            <p>使用虚拟机进行注册、登录或使用的行为。</p>
            <p>10、进行赌博或变相赌博行为。</p>
            <p>11、利用父母牵缘向其他平台引流，经父母牵缘审核系统判断可能导致诈骗等违法行为，或其他可能危害其他用户安全的行为（包括但不限于向用户发送其他平台的添加好友途径、引导用户通过父母牵缘以外的平台进行沟通等）。</p>
            <p>12、在平台上发布关于伪基站和改号软件的行为。包括但不限于以下行为：</p>
            <p>利用改号软件冒充他人诈骗的行为。</p>
            <p>宣传伪基站/改号软件的行为，如：介绍、宣传关于伪基站/改号软件的信息；展示伪基站/改号软件的使用效果；劝说他人使用伪基站/改号软件等。</p>
            <p>售卖伪基站/改号软件的行为，如：发布出售伪基站设备/改号软件的信息；发布求购伪基站设备/改号软件的信息；询问或发布伪基站设备/改号软件的售卖途径等。</p>
            <p>13、经用户举报，存在其他违反国家法律规定或扰乱父母牵缘平台社交环境的行为。</p>
            <p>三、处罚机制</p>
            <p>出现以上违规行为的，将被禁用父母牵缘账号的部分功能，限制与其他人的互动，父母牵缘有权屏蔽违规内容。</p>
            <p>情节严重或多次违反的，父母牵缘有权封禁、冻结账号，并采取禁言等相关措施，具体时间以及措施种类由用户的行为的性质及程度决定。涉及违法犯罪的，父母牵缘有权将账号信息移交司法机关。对于因违规被永久封禁的账号，无法申请注销。</p>
            <p>对于用户为逃避处罚而采取的规避措施（包括但不限于重新注册账号等），经父母牵缘认定系同一用户所为的，此种情形注册的所有账号，父母牵缘将按照同一账号处理，采取同等处罚措施。</p>
            <p>若在使用中发现他人账号存在违反法律或用户行为规范的信息，可在举报页面进行反馈，核实后我们会及时处理。</p>
            <div class="footer">
                <p>江苏爱驿站信息科技有限公司</p>
            </div>
        </div>
    </div>

    <!--回到顶部-->
<!--    <van-back-top style="background-color: #fe405f"/>-->
</template>

<style lang="scss" scoped>
.agreement{
    display: flex;
    width: 100%;
    //min-height: 300px;
    background: #F8F8F8;
    .container{
        margin: 10px 10px 20px 10px;
        padding: 10px;
        background: #fff;
        text-align: left;
        border-radius: 10px;
    }
}
p {
    //margin-top: 3px;
    text-indent: 2em;
    line-height: 24px;
    font-size: 15px;
    color: #000000;
}

.footer{
    display: flex;
    text-align: right;
    float: right;
    p{
        font-size: 16px;
        color: #000000;
    }
}
</style>
<script setup lang="ts">
</script>